import React, { useEffect, useRef } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { Chart } from "chart.js/auto";
import "./PortalHome.css";
import "./MainDashboards/MainDashboard.css"; // reuses .card styles

// Import only the chart components, not the full dashboard pages.
import { MonthlySalesUnitsChart as VantisMonthlySalesAndUnitsChart, } from "./MainDashboards/VantisMainDashboard";
import { MonthlySalesUnitsChart as VasorumMonthlySalesAndUnitsChart, } from "./MainDashboards/VasorumMainDashboard";

// object mapping companyId to the appropriate preview component for that company.
const previewByCompany = {
  vantis: VantisMonthlySalesAndUnitsChart,
  vasorum: VasorumMonthlySalesAndUnitsChart,
};

const PortalHome = () => {
  const { 
            user,
            files, 
            metricsServerData,
            sourceFile,
            companyId,
            loading,
            error,
            niceMoney,
            formatNumber,
        } =useOutletContext();

    const topPreview = metricsServerData?.top100Last9Months?.topHospitals9Months.slice(0, 10) || [];
    //   console.log(topPreview);
    const salesQtyByMonthPreview = (metricsServerData?.salesQtyByMonthHistorically?.salesByMonth ?? []).slice(-12).reverse();
    //   console.log(salesQtyByMonthPreview);
    const monthlySalesDataPoints = metricsServerData?.mainDashboard?.monthlySalesDataPoints ?? [];
      // console.log(monthlySalesDataPoints);

    const MonthlySalesAndUnitsPreview = // use the appropriate preview component for the current company (default to Vasorum if companyId is not recognized or missing)
      previewByCompany[companyId] || VasorumMonthlySalesAndUnitsChart;


  return (
    <main>

        <p>Welcome, {user.name || "User not detected"}</p>
        <p>Company folder: {companyId?.charAt(0).toUpperCase() + companyId?.slice(1) || "Company Folder not detected"}</p>

        {loading && <p>Loading...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {!loading && !error && (
            <>
                {/* File list */}
                <h2 style={{ marginTop: "2rem" }}>Available File Exports</h2>
                {files.length === 0 ? (
                    <p>No export files found.</p>
                ) : (
                    <ul style={{ listStyle: "none", padding: 0 }}>
                    {files.map((f) => (
                        <li key={f}>{f}</li>
                    ))}
                    </ul>
                )}

                {/* QuickBooks Summary */}
                {metricsServerData && (
                    <>
                        <h2 style={{ marginTop: "2rem" }}>Company Summary</h2>
                        {/* <p>
                            Source file:{" "}
                            <strong>{sourceFile || "unknown"}</strong>
                        </p> */}

                        {/* Company Wide Summary */}
                        <div style={{ marginTop: "1rem" }}>
                            <p>
                                <strong>Total Sales:</strong>{" "}
                                {niceMoney(metricsServerData.salesQtyByMonthHistorically.totalSales)}
                            </p>
                            <p>
                                <strong>Total Qty:</strong>{" "}
                                {formatNumber(metricsServerData.salesQtyByMonthHistorically.totalQty)}
                            </p>
                            <p>
                                <strong>Invoice Count:</strong>{" "}
                                {formatNumber(metricsServerData.salesQtyByMonthHistorically.invoiceCount)}
                            </p>
                        </div>

                        {/* Trailing 5 Qtr Monthly Sales & Units (Company Wide) PREVIEW Button */}
                       <Link
                            to="Main-Dashboard"
                            className="portalMetricLink"
                            state={{
                                metrics: metricsServerData,
                                sourceFile: metricsServerData.sourceFile,
                                companyId: metricsServerData.companyId,
                            }}
                        >
                            <div className="portalMetricCard">
                                <div className="portalMetricCardHeader">
                                <h3 className="portalMetricCardTitle"> Main Dashboard</h3>
                                <span className="portalMetricCardTitle">
                                    Trailing 5 Qtr Monthly Sales & Units (Company Wide)
                                </span>
                                <span className="portalMetricCardHint">Click for full Main dashboard →</span>
                                </div>

                                <MonthlySalesAndUnitsPreview
                                dataPoints={monthlySalesDataPoints}
                                height={260}
                                formatMoney={niceMoney}
                                />
                            </div>
                        </Link>



                        {/* Top Hospitals (Last 9 Months) PREVIEW Button */}
                        {topPreview.length > 0 && (
                            <Link
                                to="Last-9-Months-Sales"
                                className="portalMetricLink"
                                state={{
                                metrics: metricsServerData,
                                sourceFile: metricsServerData.sourceFile,
                                companyId: metricsServerData.companyId,
                                }}>
                                <div className="portalMetricCard">
                                <div className="portalMetricCardHeader">
                                    <h3 className="portalMetricCardTitle">Top 100 Hospitals (Last 9 Months Sales)</h3>
                                    <span className="portalMetricCardHint">Click for full table →</span>
                                </div>
        
                                <table className="portalMetricTable">
                                    <thead>
                                    <tr>
                                        <th className="portalTextLeft">Hospital</th>
                                        <th className="portalTextRight">Total Sales Last 9 Months</th>
                                        <th className="portalTextRight">9 Month Average</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {topPreview.map((r, i) => (
                                        <tr key={`${r.customer}-${i}`}>
                                        <td className="portalTextLeft">{r.customer}</td>
                                        <td className="portalTextRight">{niceMoney(r.sales)}</td>
                                        <td className="portalTextRight">{niceMoney(r.sales /9)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
        
                                <div className="portalMetricFooter">
                                    Showing top {topPreview.length} of {metricsServerData.top100Last9Months.topHospitals9Months.length}
                                </div>
                                </div>
                            </Link>
                        )}


                        {/* Company Wide Sales & Qty by Month Historically PREVIEW Button */}
                        {salesQtyByMonthPreview && (
                            <Link
                                to="Sales-qty-by-month"
                                className="portalMetricLink"
                                state={{
                                    metrics: metricsServerData,
                                    sourceFile: metricsServerData.sourceFile,
                                    companyId: metricsServerData.companyId,
                                }}
                            >
                                <div className="portalMetricCard">
                                    <div className="portalMetricCardHeader">
                                        <h3 className="portalMetricCardTitle">Sales & Qty by Month - (Company-Wide)</h3>
                                        <span className="portalMetricCardHint">Click for full table →</span>
                                    </div>

                                    <table className="portalMetricTable">
                                        <thead>
                                            <tr>
                                                <th className="portalTextLeft">Month</th>
                                                <th className="portalTextRight">Total Sales</th>
                                                <th className="portalTextRight">Total Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {salesQtyByMonthPreview.map((r, i) => (
                                                <tr key={`${r.month}-${i}`}>
                                                    <td className="portalTextLeft">{r.month}</td>
                                                    <td className="portalTextRight">{niceMoney(r.sales)}</td>
                                                    <td className="portalTextRight">{formatNumber(r.qty)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <div className="portalMetricFooter">
                                        Showing {salesQtyByMonthPreview.length} months of data
                                    </div>
                                </div>
                            </Link>
                        )}
                    </>
                )}
            </>
        )}
    </main>

    );
};



export default PortalHome;
